/**
 * Идентификатор товара в каталоге: в JSON с бэка — {@code id}; ранее мог приходить как {@code itemId}.
 */
export function catalogItemId(item) {
    if (item == null) {
        return undefined;
    }
    return item.id ?? item.itemId;
}

/** Есть ли у объекта каталога валидный числовой id для API и навигации. */
export function hasCatalogItemId(item) {
    const raw = catalogItemId(item);
    if (raw == null || raw === '') return false;
    return Number.isFinite(Number(raw));
}
